module.exports = __webpack_public_path__ + "img/deepink.cf4ae857.jpg";